import {connect} from 'react-redux';

import {getKeyList, generateNewApiKey} from '../../actions/client/apiPage';

import ApiPage from './ApiPage';
import {LOCAL_STORAGE_USER_INFO_DIALER} from '../../const';

const mapState = ({client_api_page, auth}) => ({
    keyList: client_api_page.items,
    count: client_api_page.count,
    newItem: client_api_page.newItem,
    loading: client_api_page.loading,
    accountSession: localStorage.getItem(LOCAL_STORAGE_USER_INFO_DIALER) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_INFO_DIALER)).session :
        auth.info ? auth.info.session : auth.accountInfo ? auth.accountInfo.session : {},
    permissions: auth.permissions
});

export default connect(mapState,
    {
        getKeyList,
        generateNewApiKey
    })(ApiPage);